export const getEntityTypeDisplayName = (entityType: number): string => {
  switch (entityType) {
    case 1:
      return "Pracownik";
    case 2:
      return "Urządzenie";
    case 3:
      return "Przekierowanie stali";
    default:
      return "Nieznany typ";
  }
}; 